import { SurveyGameScreen } from '@/screens/mini-games'

export default function () {
  return <SurveyGameScreen />
}
